export default __webpack_public_path__ + "static/media/selected.f8092eec.svg";